import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-aseshome',
    templateUrl: './aseshome.component.html',
    styleUrls: ['./aseshome.component.scss']
})
export class AseshomeComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Bachelors Degree in Physical Education – ARNI School of Education & Sports');
        this.meta.updateTag({
            name: 'description',
            content: `Pursue a Bachelors Degree in Physical Education at ARNI School of Education & Sports. Build your career in sports, fitness, and physical education with expert guidance.`
        });
    }

}
